export class DebtorRequest {
  constructor(
    public gender: string,
    public language: string,
    public firstName: string,
    public lastName: string,
    public birthDate: string,
    public profession: string,

    public country: string,
    public postCode: string,
    public city: string,
    public box: string,
    public boxNumber: string,
    public address: string,

    public email: string,
    public phone: string,
    public mobile: string,

    public iban: string,
    public externalIdentifier: string
  ) {}
}
